<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
			<path
				class="regular"
				fill="currentColor"
				d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l104 208c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l104-208c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L256 322.3 173.5 157.3z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'CircleVIcon',
	components: { Icon },
	props,
}
</script>
